import { render, staticRenderFns } from "./exameextracao.vue?vue&type=template&id=90a19dce&"
import script from "./exameextracao.vue?vue&type=script&lang=js&"
export * from "./exameextracao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports